import { jsx as t, jsxs as I, Fragment as W } from "react/jsx-runtime";
import { AlertGroup as Zt, Alert as en, AlertVariant as Le, AlertActionCloseButton as tn, Page as nn, Modal as vt, ModalVariant as rn, TextContent as an, Text as Ce, Button as q, Spinner as Ct, FormHelperText as Ge, HelperText as Ke, HelperTextItem as We, Popover as ln, Icon as Be, FormGroup as It, NumberInput as sn, ValidatedOptions as j, InputGroup as xe, InputGroupItem as Ne, TextInput as Te, Select as Se, SelectList as Ee, SelectOption as ze, MenuToggle as pe, MenuToggleStatus as Je, TextInputGroup as kt, TextInputGroupMain as wt, ChipGroup as Ye, Chip as Qe, TextInputGroupUtilities as xt, Switch as on, TextArea as Tt, FileUpload as cn, Title as dn, Card as un, CardHeader as hn, CardTitle as pn, CardBody as mn, Grid as fn, GridItem as it, PageSection as gn, JumpLinks as yn, JumpLinksItem as bn, ButtonVariant as ke, Checkbox as vn, Radio as Cn, MenuFooter as In, Dropdown as kn, DropdownList as wn, DropdownItem as ot, Masthead as xn, MastheadToggle as Tn, PageToggleButton as Sn, MastheadBrand as En, MastheadContent as An, Toolbar as Ie, ToolbarContent as _e, ToolbarItem as K, Avatar as Rn, Bullseye as Pn, EmptyState as Dn, EmptyStateIcon as ct, EmptyStateHeader as On, EmptyStateBody as Fn, EmptyStateFooter as Vn, EmptyStateActions as Mn, SearchInput as Ln, Divider as Bn, Pagination as Nn, Badge as _n } from "@patternfly/react-core";
import { createContext as St, useContext as Et, useRef as Y, useEffect as ie, useCallback as he, useState as A, useMemo as U, forwardRef as qn, useId as At, Fragment as Rt, Children as Pt, Component as $n, isValidElement as Un } from "react";
import { useTranslation as $ } from "react-i18next";
import { NetworkError as Dt } from "@passport/passport-admin-client";
import Hn from "keycloak-js";
import { ExclamationCircleIcon as jn, ExclamationTriangleIcon as Gn, HelpIcon as Kn, EyeIcon as Wn, EyeSlashIcon as zn, TimesIcon as Ot, CubeIcon as Jn, PaypalIcon as Yn, InstagramIcon as Qn, BitbucketIcon as Xn, MicrosoftIcon as Zn, TwitterIcon as er, StackOverflowIcon as tr, OpenshiftIcon as nr, LinkedinIcon as rr, GoogleIcon as ar, GitlabIcon as lr, FacebookSquareIcon as sr, GithubIcon as ir, MinusCircleIcon as or, PlusCircleIcon as Ft, EllipsisVIcon as cr, BarsIcon as dr, SearchIcon as ur, SyncAltIcon as hr } from "@patternfly/react-icons";
import { useFormContext as Ae, Controller as oe, useController as Re, FormProvider as pr, useWatch as mr } from "react-hook-form";
import { get as _, cloneDeep as fr, intersectionBy as gr } from "lodash-es";
import be from "@patternfly/react-styles/css/components/Avatar/avatar";
import { css as yr } from "@patternfly/react-styles";
import { Table as br, TableVariant as vr, Thead as Cr, Tr as ve, Th as Ve, Tbody as dt, Td as le, ExpandableRowContent as Ir, ActionsColumn as kr, TableText as wr } from "@patternfly/react-table";
import './main.css';function Xe(e, n) {
  const r = St(n);
  return r.displayName = e, r;
}
const xr = ["error", "errorMessage"], Me = "error_description";
function Tr(e) {
  if (typeof e == "string")
    return e;
  if (e instanceof Dt)
    return Vt(e.responseData);
  if (e instanceof Error)
    return e.message;
  throw new Error("Unable to determine error message.");
}
function Sr(e) {
  if (!(e instanceof Dt))
    return;
  const n = e.responseData;
  return Er(n);
}
function Er(e) {
  if (typeof e == "object" && e !== null && Me in e && typeof e[Me] == "string")
    return e[Me];
}
function Vt(e) {
  if (!(typeof e != "object" || e === null))
    for (const n of xr) {
      const r = e[n];
      if (typeof r == "string")
        return r;
    }
}
const Ar = () => Math.floor(Math.random() * 1e3);
function Rr(e) {
  return e != null;
}
function Ze(e) {
  const n = Et(e);
  if (Rr(n))
    return n;
  throw new Error(
    `No provider found for ${e.displayName ? `the '${e.displayName}'` : "an unknown"} context, make sure it is included in your component hierarchy.`
  );
}
function Pr() {
  const e = Y(!1), n = Y(/* @__PURE__ */ new Set());
  ie(() => (e.current = !1, () => {
    e.current = !0, r();
  }), []);
  function r() {
    n.current.forEach((a) => clearTimeout(a)), n.current.clear();
  }
  return he((a, l) => {
    if (e.current)
      throw new Error("Can't schedule a timeout on an unmounted component.");
    const s = Number(setTimeout(i, l));
    n.current.add(s);
    function i() {
      n.current.delete(s), a();
    }
    return function() {
      clearTimeout(s), n.current.delete(s);
    };
  }, []);
}
function Dr({ alerts: e, onCloseAlert: n }) {
  return /* @__PURE__ */ t(
    Zt,
    {
      "data-testid": "global-alerts",
      isToast: !0,
      style: { whiteSpace: "pre-wrap" },
      children: e.map(({ id: r, variant: a, message: l, description: s }, i) => /* @__PURE__ */ t(
        en,
        {
          "data-testid": i === 0 ? "last-alert" : void 0,
          isLiveRegion: !0,
          variant: Le[a],
          component: "p",
          variantLabel: "",
          title: l,
          actionClose: /* @__PURE__ */ t(
            tn,
            {
              title: l,
              onClose: () => n(r)
            }
          ),
          children: s && /* @__PURE__ */ t("p", { children: s })
        },
        r
      ))
    }
  );
}
const Or = 8e3, Mt = Xe(
  "AlertContext",
  void 0
), qa = () => Ze(Mt), Fr = ({ children: e }) => {
  const { t: n } = $(), r = Pr(), [a, l] = A([]), s = (d) => l((h) => h.filter((c) => c.id !== d)), i = he(
    (d, h = Le.success, c) => {
      const y = {
        id: Ar(),
        message: d,
        variant: h,
        description: c
      };
      l((g) => [y, ...g]), r(() => s(y.id), Or);
    },
    [r]
  ), o = he(
    (d, h) => {
      const c = n(d, { error: Tr(h) }), y = Sr(h);
      i(c, Le.danger, y);
    },
    [i, n]
  ), u = U(() => ({ addAlert: i, addError: o }), [i, o]);
  return /* @__PURE__ */ I(Mt.Provider, { value: u, children: [
    /* @__PURE__ */ t(Dr, { alerts: a, onCloseAlert: s }),
    e
  ] });
}, Vr = (e) => {
  const { t: n, i18n: r } = $(), a = e.error, l = Mr(a), s = Vt(a);
  console.error(a);
  function i() {
    location.href = location.origin + location.pathname;
  }
  return /* @__PURE__ */ t(nn, { children: /* @__PURE__ */ t(
    vt,
    {
      variant: rn.small,
      title: n("somethingWentWrong"),
      titleIconVariant: "danger",
      showClose: !1,
      isOpen: !0,
      actions: [
        /* @__PURE__ */ t(q, { variant: "primary", onClick: i, children: n("tryAgain") }, "tryAgain")
      ],
      children: /* @__PURE__ */ t(an, { children: l ? /* @__PURE__ */ t(Ce, { children: n(l) }) : s && r.exists(s) ? /* @__PURE__ */ t(Ce, { children: n(s) }) : /* @__PURE__ */ t(Ce, { children: n("somethingWentWrongDescription") }) })
    }
  ) });
};
function Mr(e) {
  return e instanceof Error ? e.message : null;
}
function Lr(e, n, r) {
  const [a, l] = A(
    () => e.getItem(n) ?? r
  ), s = he((i) => {
    l(i), e.setItem(n, i);
  }, []);
  return ie(() => {
    l(e.getItem(n) ?? r), window.addEventListener("storage", i);
    function i(o) {
      o.storageArea === e && (o.key === null || o.key === n) && l(o.newValue ?? r);
    }
    return () => window.removeEventListener("storage", i);
  }, [e, n]), [a, s];
}
function Lt(e, n, r) {
  const a = U(
    () => JSON.stringify(r),
    [r]
  ), [l, s] = Lr(
    e,
    n,
    a
  ), i = U(() => JSON.parse(l), [l]), o = he(
    (u) => s(JSON.stringify(u)),
    []
  );
  return [i, o];
}
const Bt = Xe(
  "HelpContext",
  void 0
), Br = () => Ze(Bt), Nr = ({ children: e }) => {
  const [n, r] = Lt(localStorage, "helpEnabled", !0);
  function a() {
    r(!n);
  }
  return /* @__PURE__ */ t(Bt.Provider, { value: { enabled: n, toggleHelp: a }, children: e });
}, _r = () => St(void 0);
let qe;
const $a = () => {
  const e = Et(qe);
  if (!e)
    throw Error(
      "no environment provider in the hierarchy make sure to add the provider"
    );
  return e;
}, Ua = ({
  environment: e,
  children: n
}) => {
  qe = _r();
  const r = Y(!1), [a, l] = A(!1), [s, i] = A(), o = U(() => {
    const u = new Hn({
      url: e.serverBaseUrl,
      realm: e.realm,
      clientId: e.clientId
    });
    return u.onAuthLogout = () => u.login(), u;
  }, [e]);
  return ie(() => {
    if (r.current)
      return;
    o.init({
      onLoad: "login-required",
      pkceMethod: "S256",
      responseMode: "query",
      scope: e.scope
    }).then(() => l(!0)).catch((d) => i(d)), r.current = !0;
  }, [o]), s ? /* @__PURE__ */ t(Vr, { error: s }) : a ? /* @__PURE__ */ t(qe.Provider, { value: { environment: e, passport: o }, children: /* @__PURE__ */ t(Fr, { children: /* @__PURE__ */ t(Nr, { children: n }) }) }) : /* @__PURE__ */ t(Ct, {});
};
function Ha() {
  const n = document.getElementById("environment")?.textContent;
  if (typeof n != "string")
    throw new Error("Environment variables not found in the document.");
  try {
    return JSON.parse(n);
  } catch {
    throw new Error("Unable to parse environment variables as JSON.");
  }
}
const ja = ({
  modalTitle: e,
  continueLabel: n,
  cancelLabel: r,
  buttonTitle: a,
  isDisabled: l,
  buttonVariant: s,
  buttonTestRole: i,
  onContinue: o,
  component: u = q,
  children: d,
  ...h
}) => {
  const [c, y] = A(!1);
  return /* @__PURE__ */ I(W, { children: [
    /* @__PURE__ */ t(
      u,
      {
        variant: s,
        onClick: () => y(!0),
        isDisabled: l,
        "data-testrole": i,
        children: a
      }
    ),
    /* @__PURE__ */ t(
      vt,
      {
        variant: "small",
        ...h,
        title: e,
        isOpen: c,
        onClose: () => y(!1),
        actions: [
          /* @__PURE__ */ t(
            q,
            {
              id: "modal-confirm",
              variant: "primary",
              onClick: () => {
                y(!1), o();
              },
              children: n
            },
            "confirm"
          ),
          /* @__PURE__ */ t(
            q,
            {
              id: "modal-cancel",
              variant: "secondary",
              onClick: () => y(!1),
              children: r
            },
            "cancel"
          )
        ],
        children: d
      }
    )
  ] });
}, Nt = ({ message: e, ...n }) => /* @__PURE__ */ t(Ge, { ...n, children: /* @__PURE__ */ t(Ke, { children: /* @__PURE__ */ t(We, { icon: /* @__PURE__ */ t(jn, {}), variant: "error", children: e }) }) }), _t = ({
  helpText: e,
  fieldLabelId: n,
  noVerticalAlign: r = !0,
  unWrap: a = !1,
  isRecommendation: l = !1
}) => {
  const { enabled: s } = Br(), i = l ? Gn : Kn;
  return s ? /* @__PURE__ */ t(ln, { bodyContent: e, children: /* @__PURE__ */ I(W, { children: [
    !a && /* @__PURE__ */ t(
      "button",
      {
        "data-testid": `help-label-${n}`,
        "aria-label": n,
        onClick: (o) => o.preventDefault(),
        className: "pf-v5-c-form__group-label-help",
        children: /* @__PURE__ */ t(
          Be,
          {
            isInline: r,
            status: l ? "warning" : void 0,
            children: /* @__PURE__ */ t(i, {})
          }
        )
      }
    ),
    a && /* @__PURE__ */ t(
      Be,
      {
        isInline: r,
        status: l ? "warning" : void 0,
        children: /* @__PURE__ */ t(i, {})
      }
    )
  ] }) }) : null;
};
function ce(e) {
  if (!(typeof e > "u" || e instanceof RegExp))
    return typeof e == "object" ? e.value : e;
}
const Q = ({
  id: e,
  name: n,
  label: r,
  labelIcon: a,
  error: l,
  children: s,
  ...i
}) => /* @__PURE__ */ I(
  It,
  {
    label: r || n,
    fieldId: e || n,
    labelIcon: a ? /* @__PURE__ */ t(_t, { helpText: a, fieldLabelId: e || n }) : void 0,
    ...i,
    children: [
      s,
      l && /* @__PURE__ */ t(Nt, { "data-testid": `${n}-helper`, message: l.message })
    ]
  }
), Ga = ({
  name: e,
  label: n,
  controller: r,
  labelIcon: a,
  ...l
}) => {
  const {
    control: s,
    formState: { errors: i }
  } = Ae();
  return /* @__PURE__ */ t(
    Q,
    {
      name: e,
      label: n,
      isRequired: r.rules?.required === !0,
      error: i[e],
      labelIcon: a,
      children: /* @__PURE__ */ t(
        oe,
        {
          ...r,
          name: e,
          control: s,
          render: ({ field: o }) => {
            const u = !!r.rules?.required, d = ce(r.rules?.min), h = o.value ?? r.defaultValue, c = (y) => o.onChange(
              d !== void 0 ? Math.max(y, Number(d)) : y
            );
            return /* @__PURE__ */ t(
              sn,
              {
                ...l,
                id: e,
                value: h,
                validated: i[e] ? j.error : j.default,
                required: u,
                min: Number(d),
                max: Number(r.rules?.max),
                onPlus: () => c(h + 1),
                onMinus: () => c(h - 1),
                onChange: (y) => {
                  const g = Number(y.currentTarget.value);
                  c(isNaN(g) ? r.defaultValue : g);
                }
              }
            );
          }
        }
      )
    }
  );
}, qr = ({
  hasReveal: e = !0,
  innerRef: n,
  ...r
}) => {
  const { t: a } = $(), [l, s] = A(!0);
  return /* @__PURE__ */ I(xe, { children: [
    /* @__PURE__ */ t(Ne, { isFill: !0, children: /* @__PURE__ */ t(
      Te,
      {
        ...r,
        type: l ? "password" : "text",
        ref: n
      }
    ) }),
    e && /* @__PURE__ */ t(
      q,
      {
        variant: "control",
        "aria-label": a("showPassword"),
        onClick: () => s(!l),
        children: l ? /* @__PURE__ */ t(Wn, {}) : /* @__PURE__ */ t(zn, {})
      }
    )
  ] });
}, qt = qn(
  (e, n) => /* @__PURE__ */ t(qr, { ...e, innerRef: n })
);
qt.displayName = "PasswordInput";
const Ka = (e) => {
  const { labelIcon: n, ...r } = e, a = !!ce(e.rules?.required), l = e.defaultValue ?? "", { field: s, fieldState: i } = Re({
    ...e,
    defaultValue: l
  });
  return /* @__PURE__ */ I(
    Q,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: a,
      error: i.error,
      children: [
        /* @__PURE__ */ t(
          qt,
          {
            isRequired: a,
            id: e.name,
            "data-testid": e.name,
            validated: i.error ? j.error : j.default,
            isDisabled: e.isDisabled,
            ...r,
            ...s
          }
        ),
        e.helperText && /* @__PURE__ */ t(Ge, { children: /* @__PURE__ */ t(Ke, { children: /* @__PURE__ */ t(We, { children: e.helperText }) }) })
      ]
    }
  );
}, $r = ({
  id: e,
  name: n,
  label: r,
  options: a,
  selectedOptions: l = [],
  controller: s,
  labelIcon: i,
  isDisabled: o,
  isFullWidth: u = !0,
  onSelect: d,
  ...h
}) => {
  const {
    control: c,
    formState: { errors: y }
  } = Ae(), [g, C] = A(!1), R = ce(s.rules?.required) === !0;
  return /* @__PURE__ */ t(
    Q,
    {
      id: e,
      name: n,
      label: r,
      isRequired: R,
      error: _(y, n),
      labelIcon: i,
      children: /* @__PURE__ */ t(
        oe,
        {
          ...s,
          name: n,
          control: c,
          render: ({ field: { onChange: b, value: p } }) => /* @__PURE__ */ t(
            Se,
            {
              ...h,
              variant: "default",
              onClick: () => C(!g),
              onOpenChange: () => C(!1),
              selected: re(a) ? a.filter(
                (v) => Array.isArray(p) ? p.includes(v.key) : p === v.key
              ).map((v) => v.value) : p,
              toggle: (v) => /* @__PURE__ */ t(
                pe,
                {
                  id: e || n,
                  ref: v,
                  onClick: () => C(!g),
                  isExpanded: g,
                  isFullWidth: u,
                  status: _(y, n) ? Je.danger : void 0,
                  "aria-label": r,
                  isDisabled: o,
                  children: re(a) ? a.find(
                    (S) => S.key === (Array.isArray(p) ? p[0] : p)
                  )?.value : p
                }
              ),
              onSelect: (v, S) => {
                const k = S?.toString(), f = Array.isArray(p) ? [k] : k;
                d ? d(f, b) : b(f), C(!1);
              },
              isOpen: g,
              children: /* @__PURE__ */ t(Ee, { "data-testid": `select-${n}`, children: [...a, ...l].map((v) => /* @__PURE__ */ t(ze, { value: se(v), children: et(v) ? v : v.value }, se(v))) })
            }
          )
        }
      )
    }
  );
}, ne = (e) => et(e) ? e : e.value, Ur = ({
  id: e,
  name: n,
  label: r,
  options: a,
  selectedOptions: l = [],
  controller: s,
  labelIcon: i,
  placeholderText: o,
  onFilter: u,
  variant: d,
  isFullWidth: h = !0,
  ...c
}) => {
  const {
    control: y,
    formState: { errors: g }
  } = Ae(), [C, R] = A(!1), [b, p] = A(""), [v, S] = A(0), [k, f] = A([]), x = Y(), V = ce(s.rules?.required) === !0, D = d === ue.typeaheadMulti, P = U(
    () => [
      ...a.filter(
        (m) => !l.map((E) => ne(E)).includes(ne(m))
      ),
      ...l
    ],
    [l, a]
  ), G = P.filter(
    (m) => ne(m).toLowerCase().startsWith(b.toLowerCase())
  ), O = (m, E) => {
    E.value.includes(m) ? (E.onChange(E.value.filter((T) => T !== m)), re(a) && f(
      k.filter((T) => T.key !== m)
    )) : (E.onChange([...E.value, m]), re(P) && f([
      ...k,
      P.find((T) => T.key === m)
    ]));
  }, B = (m, E) => {
    const T = G[v];
    switch (R(!0), m.key) {
      case "Enter": {
        m.preventDefault(), p(D ? "" : ne(T)), O(se(T), E), R(!1), S(0);
        break;
      }
      case "Tab":
      case "Escape": {
        R(!1), E.onChange(void 0);
        break;
      }
      case "Backspace": {
        d === ue.typeahead && E.onChange("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        m.preventDefault();
        let L = 0;
        m.key === "ArrowUp" && (v === 0 ? L = a.length - 1 : L = v - 1), m.key === "ArrowDown" && (v === a.length - 1 ? L = 0 : L = v + 1), S(L);
        break;
      }
    }
  };
  return /* @__PURE__ */ t(
    Q,
    {
      id: e,
      name: n,
      label: r,
      isRequired: V,
      error: _(g, n),
      labelIcon: i,
      children: /* @__PURE__ */ t(
        oe,
        {
          ...s,
          name: n,
          control: y,
          render: ({ field: m }) => /* @__PURE__ */ t(
            Se,
            {
              ...c,
              onOpenChange: () => R(!1),
              selected: re(P) ? P.filter(
                (E) => Array.isArray(m.value) ? m.value.includes(E.key) : m.value === E.key
              ).map((E) => E.value) : m.value,
              shouldFocusFirstItemOnOpen: !1,
              toggle: (E) => /* @__PURE__ */ t(
                pe,
                {
                  ref: E,
                  id: e || n,
                  variant: "typeahead",
                  onClick: () => {
                    R(!C), x.current?.focus();
                  },
                  isExpanded: C,
                  isFullWidth: h,
                  status: _(g, n) ? Je.danger : void 0,
                  children: /* @__PURE__ */ I(kt, { isPlain: !0, children: [
                    /* @__PURE__ */ t(
                      wt,
                      {
                        placeholder: o,
                        value: d === ue.typeahead && m.value ? re(P) ? P.find(
                          (T) => T.key === (Array.isArray(m.value) ? m.value[0] : m.value)
                        )?.value : m.value : b,
                        onClick: () => R(!C),
                        onChange: (T, L) => {
                          p(L), u?.(L);
                        },
                        onKeyDown: (T) => B(T, m),
                        autoComplete: "off",
                        innerRef: x,
                        role: "combobox",
                        isExpanded: C,
                        "aria-controls": "select-typeahead-listbox",
                        children: d === ue.typeaheadMulti && Array.isArray(m.value) && /* @__PURE__ */ t(Ye, { "aria-label": "Current selections", children: m.value.map(
                          (T, L) => /* @__PURE__ */ t(
                            Qe,
                            {
                              onClick: (N) => {
                                N.stopPropagation(), m.onChange(
                                  m.value.filter(
                                    (Z) => Z !== se(T)
                                  )
                                );
                              },
                              children: re(P) ? [
                                ...P,
                                ...k
                              ].find((N) => T === N.key)?.value : ne(T)
                            },
                            L
                          )
                        ) })
                      }
                    ),
                    /* @__PURE__ */ t(xt, { children: (!!b || m.value) && /* @__PURE__ */ t(
                      q,
                      {
                        variant: "plain",
                        onClick: () => {
                          p(""), m.onChange(D ? [] : ""), x?.current?.focus();
                        },
                        "aria-label": "Clear input value",
                        children: /* @__PURE__ */ t(Ot, { "aria-hidden": !0 })
                      }
                    ) })
                  ] })
                }
              ),
              onSelect: (E, T) => {
                E?.stopPropagation();
                const L = T?.toString();
                D && Array.isArray(m.value) ? (p(""), O(L || "", m)) : (m.onChange(Array.isArray(m.value) ? [L] : L), R(!1));
              },
              isOpen: C,
              children: /* @__PURE__ */ t(Ee, { children: G.map((E, T) => /* @__PURE__ */ t(
                ze,
                {
                  value: se(E),
                  isFocused: v === T,
                  isActive: m.value.includes(ne(E)),
                  children: ne(E)
                },
                se(E)
              )) })
            }
          )
        }
      )
    }
  );
};
var ue = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(ue || {});
const re = (e) => typeof e[0] != "string", et = (e) => typeof e == "string", se = (e) => et(e) ? e : e.key, Hr = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t($r, { ...n }) : /* @__PURE__ */ t(Ur, { ...n, variant: e }), $e = (e) => e && typeof e == "string" ? e.includes("${") : !1, Ue = (e) => e.substring(2, e.length - 1), ae = (e, n, r, a) => {
  const l = n || r, s = $e(l) ? Ue(l) : l, i = a ? `${a}.${s}` : s;
  return e(i || "");
}, He = (e, n) => ae(e, n.displayName, n.name), jr = ["username", "firstName", "lastName", "email"], $t = (e) => e && jr.includes(e), X = (e) => `${$t(e) ? "" : "attributes."}${e?.replaceAll(
  ".",
  "🍺"
)}`, Wa = (e) => e.replaceAll(".", "🍺"), Gr = (e) => e.replaceAll("🍺", ".");
function za(e, n, r) {
  (e.responseData.errors !== void 0 ? e.responseData.errors : [e.responseData]).forEach((a) => {
    const l = Object.assign(
      {},
      a.params?.map((s) => $e(s) ? r(Ue(s)) : s)
    );
    n(X(a.field), {
      message: r(
        $e(a.errorMessage) ? Ue(a.errorMessage) : a.errorMessage,
        {
          /* eslint-disable @typescript-eslint/no-misused-spread */
          ...l,
          defaultValue: a.errorMessage || a.field
        }
      ),
      type: "server"
    });
  });
}
function Pe({
  required: e
}) {
  return e;
}
function Ja(e) {
  if (typeof e != "object" || e === null || !("responseData" in e))
    return !1;
  const { responseData: n } = e;
  return ut(n) ? !0 : typeof n != "object" || n === null || !("errors" in n) || !Array.isArray(n.errors) ? !1 : n.errors.every(ut);
}
function ut(e) {
  return !(typeof e != "object" || e === null || !("field" in e) || typeof e.field != "string" || !("errorMessage" in e) || typeof e.errorMessage != "string");
}
const Ya = ({
  labelOn: e,
  stringify: n,
  defaultValue: r,
  labelIcon: a,
  ...l
}) => {
  const i = r ?? (n ? "false" : !1), { control: o } = Ae();
  return /* @__PURE__ */ t(
    Q,
    {
      hasNoPaddingTop: !0,
      name: l.name,
      isRequired: l.rules?.required === !0,
      label: l.label,
      labelIcon: a,
      children: /* @__PURE__ */ t(
        oe,
        {
          control: o,
          name: l.name,
          defaultValue: i,
          render: ({ field: { onChange: u, value: d } }) => /* @__PURE__ */ t(
            on,
            {
              ...l,
              id: l.name,
              "data-testid": Gr(l.name),
              label: e,
              "aria-label": l.label,
              isChecked: n ? d === "true" : d,
              onChange: (h, c) => {
                const y = n ? c.toString() : c;
                l.onChange?.(h, c), u(y);
              }
            }
          )
        }
      )
    }
  );
}, Qa = (e) => {
  const n = !!e.rules?.required, r = e.defaultValue ?? "", { field: a, fieldState: l } = Re({
    ...e,
    defaultValue: r
  });
  return /* @__PURE__ */ t(
    Q,
    {
      isRequired: n,
      label: e.label,
      labelIcon: e.labelIcon,
      name: e.name,
      error: l.error,
      children: /* @__PURE__ */ t(
        Tt,
        {
          isRequired: n,
          id: e.name,
          "data-testid": e.name,
          validated: l.error ? j.error : j.default,
          isDisabled: e.isDisabled,
          ...e,
          ...a
        }
      )
    }
  );
}, Xa = (e) => {
  const { labelIcon: n, helperText: r, ...a } = e, l = !!ce(e.rules?.required), s = e.defaultValue ?? "", { field: i, fieldState: o } = Re({
    ...e,
    defaultValue: s
  });
  return /* @__PURE__ */ I(
    Q,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: l,
      error: o.error,
      children: [
        /* @__PURE__ */ t(
          Te,
          {
            isRequired: l,
            id: e.name,
            "data-testid": e["data-testid"] || e.name,
            validated: o.error ? j.error : j.default,
            isDisabled: e.isDisabled,
            ...a,
            ...i
          }
        ),
        r && /* @__PURE__ */ t(Ge, { children: /* @__PURE__ */ t(Ke, { children: /* @__PURE__ */ t(We, { children: r }) }) })
      ]
    }
  );
}, Kr = Tt, Za = (e) => {
  const { labelIcon: n, ...r } = e, a = !!ce(e.rules?.required), l = e.defaultValue ?? "", { t: s } = $(), [i, o] = A(""), { field: u, fieldState: d } = Re({
    ...e,
    defaultValue: l
  });
  return /* @__PURE__ */ t(
    Q,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: a,
      error: d.error,
      children: /* @__PURE__ */ t(
        cn,
        {
          isRequired: a,
          "data-testid": e["data-testid"] || e.name,
          filename: i,
          browseButtonText: s("browse"),
          validated: d.error ? j.error : j.default,
          hideDefaultPreview: !0,
          isDisabled: e.isDisabled,
          type: "text",
          onFileInputChange: (h, c) => {
            u.onChange(c), o(c.name);
          },
          onClearClick: () => {
            u.onChange(null), o("");
          },
          ...r,
          ...u
        }
      )
    }
  );
}, el = ({ icon: e }) => {
  const n = Wr(e);
  return /* @__PURE__ */ t(Be, { size: "lg", children: /* @__PURE__ */ t(n, { alt: e }) });
};
function Wr(e) {
  switch (e) {
    case "github":
      return ir;
    case "facebook":
      return sr;
    case "gitlab":
      return lr;
    case "google":
      return ar;
    case "linkedin":
    case "linkedin-openid-connect":
      return rr;
    case "openshift-v4":
      return nr;
    case "stackoverflow":
      return tr;
    case "twitter":
      return er;
    case "microsoft":
      return Zn;
    case "bitbucket":
      return Xn;
    case "instagram":
      return Qn;
    case "paypal":
      return Yn;
    default:
      return Jn;
  }
}
const zr = "_title_180i0_2", Jr = {
  title: zr
}, Ut = ({
  id: e,
  title: n,
  headingLevel: r = "h1",
  size: a = "xl",
  ...l
}) => /* @__PURE__ */ t(
  dn,
  {
    headingLevel: r,
    size: a,
    className: Jr.title,
    id: e,
    tabIndex: 0,
    ...l,
    children: n
  }
), Yr = ({
  title: e,
  children: n,
  scrollId: r,
  className: a
}) => {
  const l = At();
  return /* @__PURE__ */ I(un, { id: l, className: a, isFlat: !0, children: [
    /* @__PURE__ */ t(hn, { className: "kc-form-panel__header", children: /* @__PURE__ */ t(pn, { tabIndex: 0, children: /* @__PURE__ */ t(Ut, { id: r, title: e }) }) }),
    /* @__PURE__ */ t(mn, { className: "kc-form-panel__body", children: n })
  ] });
}, Qr = (e) => {
  const { title: n, children: r, scrollId: a, ...l } = e;
  return /* @__PURE__ */ t("section", { ...l, style: { marginTop: "var(--pf-v5-global--spacer--lg)" }, children: /* @__PURE__ */ I(W, { children: [
    /* @__PURE__ */ t(Ut, { id: a, title: n }),
    r
  ] }) });
}, Xr = "_panel_1cdve_1", Zr = "_sticky_1cdve_5", ht = {
  panel: Xr,
  sticky: Zr
}, ea = "kc-main-content-page-container", pt = (e) => e.replace(/\s+/g, "-"), ta = ({
  label: e,
  sections: n,
  borders: r = !1,
  ...a
}) => {
  const l = U(
    () => n.filter(({ isHidden: s }) => !s),
    [n]
  );
  return /* @__PURE__ */ I(fn, { hasGutter: !0, ...a, children: [
    /* @__PURE__ */ t(it, { md: 8, sm: 12, children: l.map(({ title: s, panel: i }) => {
      const o = pt(s.toLowerCase());
      return /* @__PURE__ */ t(Rt, { children: r ? /* @__PURE__ */ t(
        Yr,
        {
          scrollId: o,
          title: s,
          className: ht.panel,
          children: i
        }
      ) : /* @__PURE__ */ t(Qr, { scrollId: o, title: s, children: i }) }, s);
    }) }),
    /* @__PURE__ */ t(it, { md: 4, sm: 12, order: { default: "-1", md: "1" }, children: /* @__PURE__ */ t(gn, { className: ht.sticky, children: /* @__PURE__ */ t(
      yn,
      {
        isVertical: !0,
        scrollableSelector: `#${ea}`,
        label: e,
        offset: 100,
        children: l.map(({ title: s }) => {
          const i = pt(s.toLowerCase());
          return /* @__PURE__ */ t(
            bn,
            {
              onClick: () => {
                const o = document.getElementById(i);
                o && o.scrollIntoView({
                  behavior: "smooth",
                  block: "start"
                });
              },
              "data-testid": `jump-link-${i}`,
              children: s
            },
            s
          );
        })
      }
    ) }) })
  ] });
}, na = (e, n, r) => (e.isValid || r) && (e.isDirty || n) && !e.isLoading && !e.isValidating && !e.isSubmitting, tl = ({
  formState: e,
  isDisabled: n = !1,
  allowInvalid: r = !1,
  allowNonDirty: a = !1,
  children: l,
  ...s
}) => /* @__PURE__ */ t(
  q,
  {
    variant: "primary",
    isDisabled: e && !na(e, a, r) || n,
    ...s,
    type: "submit",
    children: l
  }
), ra = (e) => {
  try {
    return new Intl.DisplayNames([e], { type: "language" }).of(e);
  } catch {
    return e;
  }
}, aa = ({
  t: e,
  form: n,
  supportedLocales: r,
  currentLocale: a
}) => {
  const l = U(
    () => r.map((s) => ({
      key: s,
      value: e(`locale_${s}`, ra(s) ?? s)
    })).sort((s, i) => s.value.localeCompare(i.value, a)),
    [r, a, e]
  );
  return l.length ? /* @__PURE__ */ t(pr, { ...n, children: /* @__PURE__ */ t(
    Hr,
    {
      "data-testid": "locale-select",
      name: "attributes.locale",
      label: e("selectALocale"),
      controller: { defaultValue: "" },
      options: [{ key: "", value: e("defaultLocale") }, ...l],
      variant: l.length >= 10 ? "typeahead" : "single"
    }
  ) }) : null;
}, me = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  children: l
}) => {
  const s = ae(
    e,
    r.annotations?.inputHelperTextBefore
  ), {
    formState: { errors: i }
  } = n, o = a?.(r), u = _(i, X(r.name));
  return /* @__PURE__ */ I(
    It,
    {
      label: He(e, r) || "",
      fieldId: r.name,
      isRequired: Pe(r),
      labelIcon: s ? /* @__PURE__ */ t(_t, { helpText: s, fieldLabelId: r.name }) : void 0,
      children: [
        o ? /* @__PURE__ */ I(xe, { children: [
          l,
          o
        ] }) : l,
        u && /* @__PURE__ */ t(
          Nt,
          {
            "data-testid": `${r.name}-helper`,
            message: u.message
          }
        )
      ]
    },
    r.name
  );
}, la = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  ...l
}) => /* @__PURE__ */ t(me, { t: e, form: n, attribute: r, renderer: a, children: /* @__PURE__ */ t(
  sa,
  {
    t: e,
    form: n,
    "aria-label": He(e, r),
    name: X(r.name),
    defaultValue: [r.defaultValue || ""],
    addButtonLabel: e("addMultivaluedLabel", {
      fieldLabel: He(e, r)
    }),
    ...l
  }
) }), sa = ({
  t: e,
  name: n,
  inputType: r,
  form: a,
  addButtonLabel: l,
  isDisabled: s = !1,
  defaultValue: i,
  id: o,
  ...u
}) => {
  const { register: d, setValue: h, control: c } = a, y = mr({
    name: n,
    control: c,
    defaultValue: i || ""
  }), g = U(() => Array.isArray(y) && y.length !== 0 ? y : i || [""], [y]), C = (S) => {
    p([...g.slice(0, S), ...g.slice(S + 1)]);
  }, R = () => {
    p([...g, ""]);
  }, b = (S, k) => {
    p([...g.slice(0, S), k, ...g.slice(S + 1)]);
  }, p = (S) => {
    const k = S.flatMap((f) => f);
    h(n, k, {
      shouldDirty: !0
    });
  }, v = r.startsWith("html") ? r.substring(6) : "text";
  return ie(() => {
    d(n);
  }, [d]), /* @__PURE__ */ t("div", { id: o, children: g.map((S, k) => /* @__PURE__ */ I(Rt, { children: [
    /* @__PURE__ */ I(xe, { children: [
      /* @__PURE__ */ t(Ne, { isFill: !0, children: /* @__PURE__ */ t(
        Te,
        {
          "data-testid": n + k,
          onChange: (f, x) => b(k, x),
          name: `${n}.${k}.value`,
          value: S,
          isDisabled: s,
          type: v,
          ...u
        }
      ) }),
      /* @__PURE__ */ t(Ne, { children: /* @__PURE__ */ t(
        q,
        {
          "data-testid": "remove" + k,
          variant: ke.link,
          onClick: () => C(k),
          tabIndex: -1,
          "aria-label": e("remove"),
          isDisabled: g.length === 1 || s,
          children: /* @__PURE__ */ t(or, {})
        }
      ) })
    ] }),
    k === g.length - 1 && /* @__PURE__ */ I(
      q,
      {
        variant: ke.link,
        onClick: R,
        tabIndex: -1,
        "aria-label": e("add"),
        "data-testid": "addValue",
        isDisabled: !S || s,
        children: [
          /* @__PURE__ */ t(Ft, {}),
          " ",
          e(l || "add")
        ]
      }
    )
  ] }, k)) });
}, mt = (e) => {
  const { form: n, inputType: r, attribute: a } = e, l = Pe(a), s = r.startsWith("multiselect"), i = s ? vn : Cn, o = a.validators?.options?.options || [], u = a.annotations?.inputOptionLabels || {}, d = a.annotations?.inputOptionLabelsI18nPrefix;
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    oe,
    {
      name: X(a.name),
      control: n.control,
      defaultValue: a.defaultValue,
      render: ({ field: h }) => /* @__PURE__ */ t(W, { children: o.map((c) => /* @__PURE__ */ t(
        i,
        {
          id: c,
          "data-testid": c,
          label: ae(e.t, u[c], c, d),
          value: c,
          isChecked: h.value?.includes(c),
          onChange: () => {
            s ? h.value?.includes(c) ? h.onChange(
              h.value?.filter((y) => y !== c)
            ) : h.onChange([...h.value || [], c]) : h.onChange([c]);
          },
          readOnly: a.readOnly,
          isRequired: l
        },
        c
      )) })
    }
  ) });
}, ia = ({
  toggleId: e,
  onToggle: n,
  onSelect: r,
  selections: a,
  isOpen: l,
  menuAppendTo: s,
  direction: i,
  width: o,
  maxHeight: u,
  toggleIcon: d,
  className: h,
  isDisabled: c,
  children: y,
  ...g
}) => {
  const [C, R] = A(!1), b = Y(), p = () => {
    R(!C), n(!C);
  }, v = () => s === "parent" && b.current?.parentElement || "inline", S = Pt.toArray(
    y
  );
  return /* @__PURE__ */ t(
    Se,
    {
      ref: b,
      maxMenuHeight: we(u),
      isScrollable: !0,
      popperProps: {
        appendTo: v(),
        direction: i,
        width: we(o)
      },
      ...g,
      onClick: p,
      onOpenChange: (k) => {
        k !== C && p();
      },
      selected: a,
      onSelect: (k, f) => {
        r?.(f || ""), p();
      },
      toggle: (k) => /* @__PURE__ */ t(
        pe,
        {
          id: e,
          ref: k,
          className: h,
          onClick: p,
          isExpanded: l,
          "aria-label": g["aria-label"],
          icon: d,
          isDisabled: c,
          isFullWidth: !0,
          children: S.find((f) => f.props.value === a)?.props.children || a || g["aria-label"]
        }
      ),
      isOpen: l,
      children: /* @__PURE__ */ t(Ee, { children: y })
    }
  );
}, oa = ({
  toggleId: e,
  onSelect: n,
  onToggle: r,
  onFilter: a,
  variant: l,
  validated: s,
  placeholderText: i,
  maxHeight: o,
  width: u,
  toggleIcon: d,
  direction: h,
  selections: c,
  typeAheadAriaLabel: y,
  chipGroupComponent: g,
  chipGroupProps: C,
  footer: R,
  isDisabled: b,
  children: p,
  ...v
}) => {
  const [S, k] = A(""), [f, x] = A(0), V = Y(), D = Pt.toArray(
    p
  ), P = () => {
    r?.(!v.isOpen);
  }, G = (O) => {
    const B = D[f];
    switch (r?.(!0), O.key) {
      case "Enter": {
        O.preventDefault(), l !== J.typeaheadMulti ? k(B.props.value) : k(""), n?.(B.props.value), r?.(!1), x(0);
        break;
      }
      case "Escape": {
        r?.(!1);
        break;
      }
      case "Backspace": {
        l === J.typeahead && n?.("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        O.preventDefault();
        let m = 0;
        O.key === "ArrowUp" && (f === 0 ? m = D.length - 1 : m = f - 1), O.key === "ArrowDown" && (f === D.length - 1 ? m = 0 : m = f + 1), x(m);
        break;
      }
    }
  };
  return /* @__PURE__ */ I(
    Se,
    {
      ...v,
      onClick: P,
      onOpenChange: (O) => r?.(O),
      onSelect: (O, B) => {
        n?.(B || ""), a?.(""), k("");
      },
      maxMenuHeight: we(o),
      popperProps: { direction: h, width: we(u) },
      toggle: (O) => /* @__PURE__ */ t(
        pe,
        {
          ref: O,
          id: e,
          variant: "typeahead",
          onClick: () => r?.(!0),
          icon: d,
          isDisabled: b,
          isExpanded: v.isOpen,
          isFullWidth: !0,
          status: s === "error" ? Je.danger : void 0,
          children: /* @__PURE__ */ I(kt, { isPlain: !0, children: [
            /* @__PURE__ */ t(
              wt,
              {
                placeholder: i,
                value: l === J.typeahead && c ? c : S,
                onClick: P,
                onChange: (B, m) => {
                  k(m), a?.(m);
                },
                onKeyDown: (B) => G(B),
                autoComplete: "off",
                innerRef: V,
                role: "combobox",
                isExpanded: v.isOpen,
                "aria-controls": "select-typeahead-listbox",
                "aria-label": y,
                children: l === J.typeaheadMulti && Array.isArray(c) && (g || /* @__PURE__ */ t(Ye, { ...C, children: c.map((B, m) => /* @__PURE__ */ t(
                  Qe,
                  {
                    onClick: (E) => {
                      E.stopPropagation(), n?.(B);
                    },
                    children: B
                  },
                  m
                )) }))
              }
            ),
            /* @__PURE__ */ t(xt, { children: !!S && /* @__PURE__ */ t(
              q,
              {
                variant: "plain",
                onClick: () => {
                  n?.(""), k(""), a?.(""), V?.current?.focus();
                },
                "aria-label": "Clear input value",
                children: /* @__PURE__ */ t(Ot, { "aria-hidden": !0 })
              }
            ) })
          ] })
        }
      ),
      children: [
        /* @__PURE__ */ t(Ee, { children: p }),
        R && /* @__PURE__ */ t(In, { children: R })
      ]
    }
  );
};
var J = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(J || {});
const we = (e) => typeof e == "number" ? e + "px" : e, ca = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t(ia, { ...n }) : /* @__PURE__ */ t(oa, { ...n, variant: e }), ft = (e) => {
  const { t: n, form: r, inputType: a, attribute: l } = e, [s, i] = A(!1), [o, u] = A(""), d = a === "multiselect", h = (b, p) => {
    d ? p.value?.includes(b) ? p.onChange(p.value.filter((v) => v !== b)) : Array.isArray(p.value) ? p.onChange([...p.value, b]) : p.onChange([b]) : p.onChange(b === p.value ? "" : b);
  }, c = l.validators?.options?.options || [], y = l.annotations?.inputOptionLabels || {}, g = l.annotations?.inputOptionLabelsI18nPrefix, C = (b) => ae(e.t, y[b], b, g), R = (b) => c.filter(
    (p) => C(p).toLowerCase().includes(o.toLowerCase())
  ).map((p) => /* @__PURE__ */ t(
    ze,
    {
      selected: b === p,
      value: p,
      children: C(p)
    },
    p
  ));
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    oe,
    {
      name: X(l.name),
      defaultValue: l.defaultValue,
      control: r.control,
      render: ({ field: b }) => /* @__PURE__ */ t(
        ca,
        {
          toggleId: l.name,
          onToggle: (p) => i(p),
          onClear: () => h("", b),
          onSelect: (p) => {
            const v = p.toString();
            h(v, b), Array.isArray(b.value) || i(!1);
          },
          selections: d && Array.isArray(b.value) ? b.value.map((p) => C(p)) : C(b.value),
          variant: d ? J.typeaheadMulti : c.length >= 10 ? J.typeahead : J.single,
          "aria-label": n("selectOne"),
          isOpen: s,
          isDisabled: l.readOnly,
          onFilter: (p) => (u(p), R(b.value)),
          children: R(b.value)
        }
      )
    }
  ) });
}, da = (e) => {
  const { form: n, attribute: r } = e, a = Pe(r);
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    Kr,
    {
      id: r.name,
      "data-testid": r.name,
      ...n.register(X(r.name)),
      cols: r.annotations?.inputTypeCols,
      rows: r.annotations?.inputTypeRows,
      readOnly: r.readOnly,
      isRequired: a,
      defaultValue: r.defaultValue
    }
  ) });
}, H = (e) => {
  const { form: n, inputType: r, attribute: a } = e, l = Pe(a), s = r.startsWith("html") ? r.substring(6) : "text";
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    Te,
    {
      id: a.name,
      "data-testid": a.name,
      type: s,
      placeholder: a.readOnly ? "" : ae(
        e.t,
        a.annotations?.inputTypePlaceholder,
        "",
        a.annotations?.inputOptionLabelsI18nPrefix
      ),
      isDisabled: a.readOnly,
      isRequired: l,
      defaultValue: a.defaultValue,
      ...n.register(X(a.name))
    }
  ) });
}, je = {
  text: H,
  textarea: da,
  select: ft,
  "select-radiobuttons": mt,
  multiselect: ft,
  "multiselect-checkboxes": mt,
  "html5-email": H,
  "html5-tel": H,
  "html5-url": H,
  "html5-number": H,
  "html5-range": H,
  "html5-datetime-local": H,
  "html5-date": H,
  "html5-month": H,
  "html5-time": H,
  "multi-input": la
}, nl = ({
  t: e,
  form: n,
  userProfileMetadata: r,
  supportedLocales: a,
  currentLocale: l,
  hideReadOnly: s = !1,
  renderer: i
}) => {
  const o = U(() => {
    if (!r.attributes)
      return [];
    const u = s ? r.attributes.filter(({ readOnly: d }) => !d) : r.attributes;
    return [
      // Insert an empty group for attributes without a group.
      { name: void 0 },
      ...r.groups ?? []
    ].map((d) => ({
      group: d,
      attributes: u.filter(
        (h) => h.group === d.name
      )
    }));
  }, [
    s,
    r.groups,
    r.attributes
  ]);
  return o.length === 0 ? null : /* @__PURE__ */ t(
    ta,
    {
      label: e("jumpToSection"),
      sections: o.filter((u) => u.attributes.length > 0).map(({ group: u, attributes: d }) => ({
        title: ae(e, u.displayHeader, u.name) || e("general"),
        panel: /* @__PURE__ */ I("div", { className: "pf-v5-c-form", children: [
          u.displayDescription && /* @__PURE__ */ t(Ce, { className: "pf-v5-u-pb-lg", children: ae(e, u.displayDescription, "") }),
          d.map((h) => /* @__PURE__ */ t(
            ua,
            {
              t: e,
              form: n,
              supportedLocales: a,
              currentLocale: l,
              renderer: i,
              attribute: h
            },
            h.name
          ))
        ] })
      }))
    }
  );
}, ua = ({
  t: e,
  form: n,
  renderer: r,
  supportedLocales: a,
  currentLocale: l,
  attribute: s
}) => {
  const i = n.watch(
    X(s.name)
  ), o = U(() => pa(s), [s]), u = s.multivalued || fa(i) && s.annotations?.inputType === void 0 ? je["multi-input"] : je[o];
  return s.name === "locale" ? /* @__PURE__ */ t(
    aa,
    {
      form: n,
      supportedLocales: a,
      currentLocale: l,
      t: e,
      attribute: s
    }
  ) : /* @__PURE__ */ t(
    u,
    {
      t: e,
      form: n,
      inputType: o,
      attribute: s,
      renderer: r
    }
  );
}, ha = "text";
function pa(e) {
  if ($t(e.name))
    return "text";
  const n = e.annotations?.inputType;
  return ma(n) ? n : ha;
}
const ma = (e) => typeof e == "string" && e in je, fa = (e) => Array.isArray(e) && e.length > 1, ga = ({
  className: e = "",
  border: n,
  size: r = "md"
}) => /* @__PURE__ */ I(
  "svg",
  {
    className: yr(
      be.avatar,
      be.modifiers[r],
      n === "light" && be.modifiers.light,
      n === "dark" && be.modifiers.dark,
      e
    ),
    enableBackground: "new 0 0 36 36",
    version: "1.1",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "circle",
        {
          style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
          cx: "18",
          cy: "18.5",
          r: "18"
        }
      ),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t(
        "filter",
        {
          id: "b",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          filterUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("feColorMatrix", { values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" })
        }
      ) }),
      /* @__PURE__ */ t(
        "mask",
        {
          id: "a",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          maskUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("g", { style: { filter: 'url("#b")' }, children: /* @__PURE__ */ t(
            "circle",
            {
              style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
              cx: "18",
              cy: "18.5",
              r: "18"
            }
          ) })
        }
      ),
      /* @__PURE__ */ t("g", { style: { filter: 'url("#a")' }, children: /* @__PURE__ */ I("g", { transform: "translate(5.04 6.88)", children: [
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m22.6 18.1c-1.1-1.4-2.3-2.2-3.5-2.6s-1.8-0.6-6.3-0.6-6.1 0.7-6.1 0.7 0 0 0 0c-1.2 0.4-2.4 1.2-3.4 2.6-2.3 2.8-3.2 12.3-3.2 14.8 0 3.2 0.4 12.3 0.6 15.4 0 0-0.4 5.5 4 5.5l-0.3-6.3-0.4-3.5 0.2-0.9c0.9 0.4 3.6 1.2 8.6 1.2 5.3 0 8-0.9 8.8-1.3l0.2 1-0.2 3.6-0.3 6.3c3 0.1 3.7-3 3.8-4.4s0.6-12.6 0.6-16.5c0.1-2.6-0.8-12.1-3.1-15z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m22.5 26c-0.1-2.1-1.5-2.8-4.8-2.8l2.2 9.6s1.8-1.7 3-1.8c0 0-0.4-4.6-0.4-5z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m12.7 13.2c-3.5 0-6.4-2.9-6.4-6.4s2.9-6.4 6.4-6.4 6.4 2.9 6.4 6.4-2.8 6.4-6.4 6.4z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.08,
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#231F20"
            },
            d: "m9.4 6.8c0-3 2.1-5.5 4.9-6.3-0.5-0.1-1-0.2-1.6-0.2-3.5 0-6.4 2.9-6.4 6.4s2.9 6.4 6.4 6.4c0.6 0 1.1-0.1 1.6-0.2-2.8-0.6-4.9-3.1-4.9-6.1z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m8.3 22.4c-2 0.4-2.9 1.4-3.1 3.5l-0.6 18.6s1.7 0.7 3.6 0.9l0.1-23z"
          }
        )
      ] }) })
    ]
  }
), gt = ({
  isKebab: e = !1,
  title: n,
  dropDownItems: r,
  ...a
}) => {
  const [l, s] = A(!1);
  return /* @__PURE__ */ t(
    kn,
    {
      ...a,
      popperProps: {
        position: "right"
      },
      onOpenChange: (i) => s(i),
      toggle: (i) => /* @__PURE__ */ t(
        pe,
        {
          "data-testid": `${a["data-testid"]}-toggle`,
          ref: i,
          onClick: () => s(!l),
          isExpanded: l,
          variant: e ? "plain" : "default",
          children: e ? /* @__PURE__ */ t(cr, {}) : n
        }
      ),
      isOpen: l,
      children: /* @__PURE__ */ t(wn, { children: r })
    }
  );
};
function ya(e, n) {
  if (!e)
    return n("unknownUser");
  const r = e.given_name, a = e.family_name, l = e.preferred_username;
  return r && a ? n("fullName", { givenName: r, familyName: a }) : r || a || l || n("unknownUser");
}
const rl = ({
  passport: e,
  brand: { src: n, alt: r, className: a, ...l },
  avatar: s,
  features: {
    hasLogout: i = !0,
    hasManageAccount: o = !0,
    hasUsername: u = !0
  } = {},
  kebabDropdownItems: d,
  dropdownItems: h = [],
  toolbarItems: c,
  toolbar: y,
  ...g
}) => {
  const { t: C } = $(), R = [];
  o && R.push(
    /* @__PURE__ */ t(
      ot,
      {
        onClick: () => e.accountManagement(),
        children: C("manageAccount")
      },
      "manageAccount"
    )
  ), i && R.push(
    /* @__PURE__ */ t(ot, { onClick: () => e.logout(), children: C("signOut") }, "signOut")
  );
  const b = e.idTokenParsed?.picture;
  return /* @__PURE__ */ I(xn, { ...g, children: [
    /* @__PURE__ */ t(Tn, { children: /* @__PURE__ */ t(Sn, { variant: "plain", "aria-label": C("navigation"), children: /* @__PURE__ */ t(dr, {}) }) }),
    /* @__PURE__ */ t(En, { ...l, children: /* @__PURE__ */ t("img", { src: n, alt: r, className: a }) }),
    /* @__PURE__ */ I(An, { children: [
      y,
      /* @__PURE__ */ t(Ie, { children: /* @__PURE__ */ I(_e, { children: [
        c?.map((p, v) => /* @__PURE__ */ t(K, { align: { default: "alignRight" }, children: p }, v)),
        /* @__PURE__ */ t(
          K,
          {
            visibility: {
              default: "hidden",
              md: "visible"
            },
            children: /* @__PURE__ */ t(
              gt,
              {
                "data-testid": "options",
                dropDownItems: [...h, R],
                title: u ? ya(e.idTokenParsed, C) : void 0
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          K,
          {
            align: { default: "alignLeft" },
            visibility: {
              md: "hidden"
            },
            children: /* @__PURE__ */ t(
              gt,
              {
                "data-testid": "options-kebab",
                isKebab: !0,
                dropDownItems: [
                  ...d || h,
                  R
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          K,
          {
            variant: "overflow-menu",
            align: { default: "alignRight" },
            className: "pf-v5-u-m-0-on-lg",
            children: b || s?.src ? /* @__PURE__ */ t(Rn, { src: b, alt: C("avatar"), ...s }) : /* @__PURE__ */ t(ga, { ...s })
          }
        )
      ] }) })
    ] })
  ] });
}, Ht = Xe("ErrorBoundaryContext", void 0), jt = () => Ze(Ht);
class al extends $n {
  state = {};
  static getDerivedStateFromError = (n) => ({ error: n });
  showBoundary = (n) => {
    this.setState({ error: n });
  };
  render() {
    return /* @__PURE__ */ t(
      Ht.Provider,
      {
        value: { error: this.state.error, showBoundary: this.showBoundary },
        children: this.props.children
      }
    );
  }
}
const ll = ({ children: e, fallback: n }) => {
  const { error: r } = jt();
  return r ? /* @__PURE__ */ t(n, { error: r }) : e;
};
function ba(e, n, r) {
  const { showBoundary: a } = jt();
  ie(() => {
    const l = new AbortController(), { signal: s } = l;
    return e().then((i) => {
      s.aborted || n(i);
    }).catch((i) => {
      console.error(i), s.aborted || a(i);
    }), () => l.abort();
  }, r);
}
const va = () => {
  const { t: e } = $();
  return /* @__PURE__ */ t(Pn, { children: /* @__PURE__ */ t(Ct, { "aria-label": e("spinnerLoading") }) });
}, Ca = ({
  message: e,
  instructions: n,
  onPrimaryAction: r,
  hasIcon: a = !0,
  isSearchVariant: l,
  primaryActionText: s,
  secondaryActions: i,
  icon: o,
  isDisabled: u = !1,
  children: d
}) => /* @__PURE__ */ I(Dn, { "data-testid": "empty-state", variant: "lg", children: [
  a && l ? /* @__PURE__ */ t(ct, { icon: ur }) : a && /* @__PURE__ */ t(ct, { icon: o || Ft }),
  /* @__PURE__ */ t(On, { titleText: e, headingLevel: "h1" }),
  /* @__PURE__ */ t(Fn, { children: n }),
  /* @__PURE__ */ I(Vn, { children: [
    s && /* @__PURE__ */ t(
      q,
      {
        "data-testid": `${e.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: "primary",
        onClick: r,
        isDisabled: u,
        children: s
      }
    ),
    d,
    i && /* @__PURE__ */ t(Mn, { children: i.map((h) => /* @__PURE__ */ t(
      q,
      {
        "data-testid": `${h.text.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: h.type || ke.secondary,
        onClick: h.onClick,
        isDisabled: u,
        children: h.text
      },
      h.text
    )) })
  ] })
] }), Ia = ({
  toolbarItem: e,
  subToolbar: n,
  toolbarItemFooter: r,
  children: a,
  searchTypeComponent: l,
  inputGroupName: s,
  inputGroupPlaceholder: i,
  inputGroupOnEnter: o
}) => {
  const { t: u } = $(), [d, h] = A(""), c = (g) => {
    h(g.trim()), o?.(g.trim());
  }, y = (g) => {
    g.key === "Enter" && c(d);
  };
  return /* @__PURE__ */ I(W, { children: [
    /* @__PURE__ */ t(Ie, { "data-testid": "table-toolbar", children: /* @__PURE__ */ I(_e, { children: [
      s && /* @__PURE__ */ t(K, { children: /* @__PURE__ */ I(xe, { "data-testid": s, children: [
        l,
        i && /* @__PURE__ */ t(
          Ln,
          {
            "data-testid": "table-search-input",
            placeholder: i,
            "aria-label": u("search"),
            value: d,
            onChange: (g, C) => {
              h(C);
            },
            onSearch: () => c(d),
            onKeyDown: y,
            onClear: () => c("")
          }
        )
      ] }) }),
      e
    ] }) }),
    n && /* @__PURE__ */ t(Ie, { children: /* @__PURE__ */ t(_e, { children: n }) }),
    /* @__PURE__ */ t(Bn, {}),
    a,
    /* @__PURE__ */ t(Ie, { children: r })
  ] });
}, yt = ({
  id: e,
  variant: n = "top",
  count: r,
  first: a,
  max: l,
  onNextClick: s,
  onPreviousClick: i,
  onPerPageSelect: o
}) => {
  const { t: u } = $(), d = Math.round(a / l);
  return /* @__PURE__ */ t(
    Nn,
    {
      widgetId: e,
      titles: {
        paginationAriaLabel: `${u("pagination")} ${n} `
      },
      isCompact: !0,
      toggleTemplate: ({
        firstIndex: h,
        lastIndex: c
      }) => /* @__PURE__ */ I("b", { children: [
        h,
        " - ",
        c
      ] }),
      itemCount: r + d * l,
      page: d + 1,
      perPage: l,
      onNextClick: (h, c) => s((c - 1) * l),
      onPreviousClick: (h, c) => i((c - 1) * l),
      onPerPageSelect: (h, c, y) => o(y - 1, c),
      variant: n
    }
  );
}, ka = ({
  count: e,
  searchTypeComponent: n,
  toolbarItem: r,
  subToolbar: a,
  children: l,
  inputGroupName: s,
  inputGroupPlaceholder: i,
  inputGroupOnEnter: o,
  ...u
}) => /* @__PURE__ */ t(
  Ia,
  {
    searchTypeComponent: n,
    toolbarItem: /* @__PURE__ */ I(W, { children: [
      r,
      /* @__PURE__ */ t(K, { variant: "pagination", children: /* @__PURE__ */ t(yt, { count: e, ...u }) })
    ] }),
    subToolbar: a,
    toolbarItemFooter: e !== 0 ? /* @__PURE__ */ t(K, { variant: "pagination", children: /* @__PURE__ */ t(yt, { count: e, variant: "bottom", ...u }) }) : null,
    inputGroupName: s,
    inputGroupPlaceholder: i,
    inputGroupOnEnter: o,
    children: l
  }
), Gt = (e) => !!e && e.title !== void 0, bt = ({
  row: e,
  index: n,
  actions: r,
  actionResolver: a
}) => {
  const l = r || a?.(e, {});
  return /* @__PURE__ */ I(W, { children: [
    e.cells.map((s, i) => /* @__PURE__ */ t(le, { children: Gt(s) ? s.title : s }, `cell-${i}`)),
    l && l.length > 0 && !e.disableActions && /* @__PURE__ */ t(le, { isActionCell: !0, children: /* @__PURE__ */ t(kr, { items: l, extraData: { rowIndex: n } }) })
  ] });
}, wa = ({ row: e }) => e.cells.map((n, r) => /* @__PURE__ */ t("div", { children: Gt(n) ? n.title : n }, `cell-${r}`));
function xa({
  columns: e,
  rows: n,
  actions: r,
  actionResolver: a,
  ariaLabelKey: l,
  selected: s,
  onSelect: i,
  onCollapse: o,
  canSelectAll: u,
  canSelect: d,
  isNotCompact: h,
  isRadio: c,
  ...y
}) {
  const { t: g } = $(), [C, R] = A(s || []), [b, p] = A([]), v = U(
    () => gr(
      C,
      n.map((f) => f.data),
      "id"
    ),
    [C, n]
  );
  ie(() => {
    if (u) {
      const f = document.getElementsByName("check-all").item(0);
      if (f) {
        const x = f;
        x.indeterminate = v.length < n.length && v.length > 0;
      }
    }
  }, [C, u, n]);
  const S = (f) => {
    R(f), i?.(f);
  }, k = (f, x) => {
    if (c) {
      const V = x ? [n[f].data] : [];
      S(V);
    } else if (f === -1) {
      const V = v.map(
        (D) => _(D, "id")
      );
      S(
        x ? [...C, ...n.map((D) => D.data)] : C.filter(
          (D) => !V.includes(_(D, "id"))
        )
      );
    } else
      S(x ? [...C, n[f].data] : C.filter(
        (V) => _(V, "id") !== n[f].data.id
      ));
  };
  return /* @__PURE__ */ I(
    br,
    {
      ...y,
      variant: h ? void 0 : vr.compact,
      "aria-label": g(l),
      children: [
        /* @__PURE__ */ t(Cr, { children: /* @__PURE__ */ I(ve, { children: [
          o && /* @__PURE__ */ t(Ve, { screenReaderText: g("expandRow") }),
          u && /* @__PURE__ */ t(
            Ve,
            {
              screenReaderText: g("selectAll"),
              select: c ? void 0 : {
                onSelect: (f, x) => {
                  k(-1, x);
                },
                isSelected: v.length === n.length
              }
            }
          ),
          e.map((f) => /* @__PURE__ */ t(
            Ve,
            {
              screenReaderText: g("expandRow"),
              className: f.transforms?.[0]().className,
              children: g(f.displayKey || f.name)
            },
            f.displayKey || f.name
          ))
        ] }) }),
        o ? n.map((f, x) => /* @__PURE__ */ t(dt, { children: x % 2 === 0 ? /* @__PURE__ */ I(ve, { children: [
          /* @__PURE__ */ t(
            le,
            {
              expand: n[x + 1].cells.length === 0 ? void 0 : {
                isExpanded: b[x] ?? !1,
                rowIndex: x,
                expandId: "expandable-row-",
                onToggle: (V, D, P) => {
                  o(P, D);
                  const G = [...b];
                  G[x] = P, p(G);
                }
              }
            }
          ),
          /* @__PURE__ */ t(
            bt,
            {
              row: f,
              index: x,
              actions: r,
              actionResolver: a
            }
          )
        ] }) : /* @__PURE__ */ I(ve, { isExpanded: b[x - 1] ?? !1, children: [
          /* @__PURE__ */ t(le, {}),
          /* @__PURE__ */ t(le, { colSpan: e.length, children: /* @__PURE__ */ t(Ir, { children: /* @__PURE__ */ t(wa, { row: f }) }) })
        ] }) }, x)) : /* @__PURE__ */ t(dt, { children: n.map((f, x) => /* @__PURE__ */ I(ve, { isExpanded: b[x], children: [
          d && /* @__PURE__ */ t(
            le,
            {
              select: {
                rowIndex: x,
                onSelect: (V, D, P) => {
                  k(P, D);
                },
                isSelected: !!C.find(
                  (V) => _(V, "id") === f.data.id
                ),
                variant: c ? "radio" : "checkbox",
                isDisabled: f.disableSelection
              }
            }
          ),
          /* @__PURE__ */ t(
            bt,
            {
              row: f,
              index: x,
              actions: r,
              actionResolver: a
            }
          )
        ] }, x)) })
      ]
    }
  );
}
function Ta({
  ariaLabelKey: e,
  searchPlaceholderKey: n,
  isPaginated: r = !1,
  onSelect: a,
  canSelectAll: l = !1,
  isNotCompact: s,
  isRadio: i,
  detailColumns: o,
  isRowDisabled: u,
  loader: d,
  columns: h,
  actions: c,
  actionResolver: y,
  searchTypeComponent: g,
  toolbarItem: C,
  subToolbar: R,
  emptyState: b,
  icon: p,
  isSearching: v = !1,
  ...S
}) {
  const { t: k } = $(), [f, x] = A([]), [V, D] = A(), [P, G] = A(), [O, B] = A(!1), [m, E] = Lt(
    localStorage,
    "pageSize",
    10
  ), [T, L] = A(m), [N, Z] = A(0), [z, De] = A(""), tt = Y(), [fe, Kt] = A(0), nt = Y(), rt = () => Kt(fe + 1), Wt = At(), at = (w, F) => w.map((M) => {
    if ("cellFormatters" in M) {
      const te = _(F, M.name);
      return M.cellFormatters?.reduce((de, ye) => ye(de), te);
    }
    if (M.cellRenderer) {
      const te = M.cellRenderer;
      return { title: /* @__PURE__ */ t(te, { ...F }) };
    }
    return _(F, M.name);
  }), lt = (w) => {
    const F = (M) => o?.[0]?.enabled?.(M);
    return w.map((M, te) => {
      const de = u ? u(M) : !1, ye = [
        {
          data: M,
          disableSelection: de,
          disableActions: de,
          selected: !!f.find((Xt) => _(Xt, "id") === _(M, "id")),
          isOpen: F(M) ? !1 : void 0,
          cells: at(h, M)
        }
      ];
      return o && ye.push({
        parent: te * 2,
        cells: F(M) ? at(o, M) : []
      }), ye;
    }).flat();
  }, Oe = (w) => ["string", "number"].includes(typeof w) ? w.toString() : w instanceof Array ? w.map(Oe).join("") : typeof w == "object" ? Oe(
    Un(w.title) ? w.title.props : Object.values(w)
  ) : "", st = U(
    () => z === "" || r ? void 0 : lt(P || []).filter(
      (w) => w.cells.some(
        (F) => F && Oe(F).toLowerCase().includes(z.toLowerCase())
      )
    ).slice(N, N + T + 1),
    [z, N, T]
  );
  ba(
    async () => {
      B(!0);
      const w = tt.current === "" && z !== "";
      return w && Z(0), tt.current = z, typeof d == "function" ? fe === nt.current && P ? P : await d(w ? 0 : N, T + 1, z) : d;
    },
    (w) => {
      nt.current = fe, r || (G(w), w.length > N ? w = w.slice(N, N + T + 1) : Z(0));
      const F = lt(w);
      D(F), B(!1);
    },
    [
      fe,
      N,
      T,
      z,
      typeof d != "function" ? d : void 0
    ]
  );
  const zt = () => c && fr(c).map((w, F) => (delete w.onRowClick, w.onClick = async (M, te) => {
    await c[F].onRowClick(
      (st || V)[te].data
    ) && (r || De(""), rt());
  }, w)), Jt = (w, F) => {
    ee[F].isOpen = w, D([...ee]);
  }, ee = st || V, ge = !ee || ee.length === 0, Fe = z !== "" || v, Yt = o ? T * 2 : T, Qt = o ? (ee?.length || 0) / 2 : ee?.length || 0;
  return /* @__PURE__ */ I(W, { children: [
    (!ge || Fe) && /* @__PURE__ */ I(
      ka,
      {
        id: Wt,
        count: Qt,
        first: N,
        max: T,
        onNextClick: Z,
        onPreviousClick: Z,
        onPerPageSelect: (w, F) => {
          Z(w), L(F), E(F);
        },
        inputGroupName: n ? `${e}input` : void 0,
        inputGroupOnEnter: De,
        inputGroupPlaceholder: k(n || ""),
        searchTypeComponent: g,
        toolbarItem: /* @__PURE__ */ I(W, { children: [
          C,
          " ",
          /* @__PURE__ */ t(K, { variant: "separator" }),
          " ",
          /* @__PURE__ */ t(K, { children: /* @__PURE__ */ I(q, { variant: "link", onClick: rt, "data-testid": "refresh", children: [
            /* @__PURE__ */ t(hr, {}),
            " ",
            k("refresh")
          ] }) })
        ] }),
        subToolbar: R,
        children: [
          !O && !ge && /* @__PURE__ */ t(
            xa,
            {
              ...S,
              canSelectAll: l,
              canSelect: !!a,
              selected: f,
              onSelect: (w) => {
                x(w), a?.(w);
              },
              onCollapse: o ? Jt : void 0,
              actions: zt(),
              actionResolver: y,
              rows: ee.slice(0, Yt),
              columns: h,
              isNotCompact: s,
              isRadio: i,
              ariaLabelKey: e
            }
          ),
          !O && ge && Fe && /* @__PURE__ */ t(
            Ca,
            {
              hasIcon: !0,
              icon: p,
              isSearchVariant: !0,
              message: k("noSearchResults"),
              instructions: k("noSearchResultsInstructions"),
              secondaryActions: v ? [] : [
                {
                  text: k("clearAllFilters"),
                  onClick: () => De(""),
                  type: ke.link
                }
              ]
            }
          )
        ]
      }
    ),
    O && /* @__PURE__ */ t(va, {}),
    !O && ge && !Fe && b
  ] });
}
const Sa = ({ link: e, organization: n }) => {
  const { t: r } = $();
  return /* @__PURE__ */ t(wr, { wrapModifier: "truncate", children: /* @__PURE__ */ I(e, { organization: n, children: [
    n.name,
    !n.enabled && /* @__PURE__ */ t(
      _n,
      {
        isRead: !0,
        className: "pf-v5-u-ml-sm",
        children: r("disabled")
      },
      `${n.id}-disabled`
    )
  ] }) });
}, Ea = (e) => {
  const { t: n } = $();
  return /* @__PURE__ */ t(
    Ye,
    {
      numChips: 2,
      expandedText: n("hide"),
      collapsedText: n("showRemaining"),
      children: e.domains?.map((r) => {
        const a = typeof r == "string" ? r : r.name;
        return /* @__PURE__ */ t(Qe, { isReadOnly: !0, children: a }, a);
      })
    }
  );
}, sl = ({
  loader: e,
  toolbarItem: n,
  isPaginated: r = !1,
  isSearching: a = !1,
  searchPlaceholderKey: l,
  onSelect: s,
  onDelete: i,
  deleteLabel: o = "delete",
  link: u,
  children: d
}) => {
  const { t: h } = $();
  return /* @__PURE__ */ t(
    Ta,
    {
      loader: e,
      isPaginated: r,
      isSearching: a,
      ariaLabelKey: "organizationList",
      searchPlaceholderKey: l,
      toolbarItem: n,
      onSelect: s,
      canSelectAll: s !== void 0,
      actions: i ? [
        {
          title: h(o),
          onRowClick: i
        }
      ] : void 0,
      columns: [
        {
          name: "name",
          displayKey: "name",
          cellRenderer: (c) => /* @__PURE__ */ t(Sa, { link: u, organization: c })
        },
        {
          name: "domains",
          displayKey: "domains",
          cellRenderer: Ea
        },
        {
          name: "description",
          displayKey: "description"
        },
        {
          name: "membershipType",
          displayKey: "membershipType"
        }
      ],
      emptyState: d
    }
  );
};
export {
  Fr as AlertProvider,
  ja as ContinueCancelModal,
  ll as ErrorBoundaryFallback,
  al as ErrorBoundaryProvider,
  Vr as ErrorPage,
  Za as FileUploadControl,
  Nt as FormErrorText,
  Yr as FormPanel,
  tl as FormSubmitButton,
  Nr as Help,
  _t as HelpItem,
  el as IconMapper,
  Ca as ListEmptyState,
  Ga as NumberControl,
  sl as OrganizationTable,
  ka as PaginatingTableToolbar,
  Ta as PassportDataTable,
  rl as PassportMasthead,
  Ua as PassportProvider,
  ca as PassportSelect,
  va as PassportSpinner,
  Kr as PassportTextArea,
  Ka as PasswordControl,
  qt as PasswordInput,
  ta as ScrollForm,
  Hr as SelectControl,
  ue as SelectVariant,
  Ya as SwitchControl,
  Ia as TableToolbar,
  Qa as TextAreaControl,
  Xa as TextControl,
  nl as UserProfileFields,
  Wa as beerify,
  Xe as createNamedContext,
  Gr as debeerify,
  Ar as generateId,
  Sr as getErrorDescription,
  Tr as getErrorMessage,
  Ha as getInjectedEnvironment,
  Er as getNetworkErrorDescription,
  Vt as getNetworkErrorMessage,
  Rr as isDefined,
  Ja as isUserProfileError,
  ae as label,
  ea as mainPageContentId,
  za as setUserProfileServerError,
  qa as useAlerts,
  $a as useEnvironment,
  jt as useErrorBoundary,
  ba as useFetch,
  Br as useHelp,
  Ze as useRequiredContext,
  Pr as useSetTimeout,
  Lt as useStoredState
};
//# sourceMappingURL=passport-ui-shared.js.map
